import React, { useState, useEffect } from 'react';
import api from '../api/client';
import './UnscannedBagsPopup.css';

const UnscannedBagsPopup = ({ isOpen, onClose }) => {
    const [unscannedBags, setUnscannedBags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedSeeds, setExpandedSeeds] = useState(new Set());

    useEffect(() => {
        if (isOpen) {
            fetchUnscannedBags();
        }
    }, [isOpen]);

    const fetchUnscannedBags = async () => {
    try {
        const response = await api.get('/api/unscanned_bags');
        const parsedData = response.data.map(bag => ({
            ...bag,
            currentWeight: bag.currentWeight ? Number(bag.currentWeight) : null,
        }));
        setUnscannedBags(parsedData);
        setLoading(false);
    } catch (err) {
        console.error('Error fetching unscanned bags:', err);
        setError('Failed to load unscanned bags');
        setLoading(false);
    }
};

    const toggleSeedExpansion = (seedsID) => {
        const newExpanded = new Set(expandedSeeds);
        if (newExpanded.has(seedsID)) {
            newExpanded.delete(seedsID);
        } else {
            newExpanded.add(seedsID);
        }
        setExpandedSeeds(newExpanded);
    };

    if (!isOpen) return null;

    if (loading) return <div className="unscanned-popup-overlay"><div className="unscanned-popup-content">Loading...</div></div>;
    if (error) return <div className="unscanned-popup-overlay"><div className="unscanned-popup-content">Error: {error}</div></div>;

    const groupedBags = unscannedBags.reduce((acc, bag) => {
        if (!acc[bag.seedsID]) {
            acc[bag.seedsID] = { combinedSeedsName: bag.combinedSeedsName, bags: [] };
        }
        acc[bag.seedsID].bags.push(bag);
        return acc;
    }, {});

    return (
        <div className="unscanned-popup-overlay">
            <div className="unscanned-popup-content">
                <button className="unscanned-popup-close-btn" onClick={onClose}>×</button>
                <h2 className="unscanned-popup-heading">Long Unscanned Bags</h2>
                {Object.keys(groupedBags).length === 0 ? (
                    <div className="unscanned-no-data">No long unscanned bags found.</div>
                ) : (
                    Object.entries(groupedBags).map(([seedsID, { combinedSeedsName, bags }]) => (
                        <div key={seedsID} className="unscanned-seed-group">
                            <div
                                className={`unscanned-seed-header ${expandedSeeds.has(seedsID) ? 'expanded' : ''}`}
                                onClick={() => toggleSeedExpansion(seedsID)}
                            >
                                <span className="unscanned-seed-name">{combinedSeedsName}</span>
                            </div>
                            {expandedSeeds.has(seedsID) && (
                                <div className="unscanned-table-container">
                                    <table className="unscanned-table">
                                        <thead className="unscanned-table-thead">
                                            <tr>
                                                <th className="unscanned-table-th">Bag Number</th>
                                                <th className="unscanned-table-th">Container</th>
                                                <th className="unscanned-table-th">Lot</th>
                                                <th className="unscanned-table-th">Weight</th>
                                                <th className="unscanned-table-th">Germ Rate</th>
                                                <th className="unscanned-table-th">Germ Date</th>
                                                <th className="unscanned-table-th">Last Check Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bags.map((bag, index) => (
                                                <tr key={index} className="unscanned-table-row">
                                                    <td className="unscanned-table-td">{bag.bagnumid}</td>
                                                    <td className="unscanned-table-td">{bag.containerName || '-'}</td>
                                                    <td className="unscanned-table-td">{bag.lot || '-'}</td>
                                                    <td className="unscanned-table-td">
                                                        {bag.currentWeight ? bag.currentWeight.toFixed(2) : '0.00'}
                                                    </td>
                                                    <td className="unscanned-table-td">{bag.germtestrate || '-'}</td>
                                                    <td className="unscanned-table-td">
                                                        {bag.germtestdate ? new Date(bag.germtestdate).toLocaleDateString() : '-'}
                                                    </td>
                                                    <td className="unscanned-table-td">
                                                        {bag.last_check_date ? new Date(bag.last_check_date).toLocaleDateString() : 'Never Checked'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default UnscannedBagsPopup;